// Registers the service worker for offline / PWA support.
// Only active in production builds — dev always hits the network.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

type Config = { onSuccess?: (reg: ServiceWorkerRegistration) => void; onUpdate?: (reg: ServiceWorkerRegistration) => void; };

export function register(config?: Config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL ?? '', window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker.register(swUrl).then((registration) => {
    registration.onupdatefound = () => {
      const installing = registration.installing;
      if (!installing) return;
      installing.onstatechange = () => {
        if (installing.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // New version available — tell it to activate immediately
            installing.postMessage({ type: 'SKIP_WAITING' });
            config?.onUpdate?.(registration);
          } else {
            config?.onSuccess?.(registration);
          }
        }
      };
    };
  }).catch(console.error);
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } }).then((res) => {
    const contentType = res.headers.get('content-type');
    if (res.status === 404 || (contentType && !contentType.includes('javascript'))) {
      navigator.serviceWorker.ready.then((r) => r.unregister()).then(() => window.location.reload());
    } else {
      registerValidSW(swUrl, config);
    }
  }).catch(() => console.log('No internet — running in offline mode.'));
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(console.error);
  }
}
